import { RouteProp, useRoute } from "@react-navigation/native";
import { useSetAtom } from "jotai";
import { useEffect } from "react";

import {
  teeSheetGroupSizeFilterAtom,
  teeSheetHoleFilterAtom,
  teeSheetTimesAtom,
} from "@/features/TeeSheet/atoms";
import { ClubStackNavigatorParamList } from "@/navigators/ClubNavigator";

export const useHandleTeeSheetQueryParams = () => {
  const route = useRoute<RouteProp<ClubStackNavigatorParamList, "Agenda">>();
  const { timeGTE, timeLTE, holeCount, groupSize } = route?.params ?? {};

  const setTimeOfDayFilter = useSetAtom(teeSheetTimesAtom);
  const setHoleCountFilter = useSetAtom(teeSheetHoleFilterAtom);
  const setGroupSizeFilter = useSetAtom(teeSheetGroupSizeFilterAtom);

  useEffect(() => {
    if (timeGTE && timeLTE) {
      setTimeOfDayFilter({ timeGTE, timeLTE });
    } else {
      setTimeOfDayFilter(undefined);
    }
  }, [setTimeOfDayFilter, timeGTE, timeLTE]);

  useEffect(() => {
    if (holeCount) {
      setHoleCountFilter(holeCount);
    } else {
      setHoleCountFilter(null);
    }
  }, [holeCount, setHoleCountFilter]);

  useEffect(() => {
    if (groupSize) {
      setGroupSizeFilter(groupSize);
    } else {
      setGroupSizeFilter(0);
    }
  }, [groupSize, setGroupSizeFilter]);
};
